// Every enquiry from the website goes through submitLead. When the Imfuyo Platform
// connection is ready, only this file changes: the same fields are sent there instead.
import { db } from '../Libs/firebase-config.mjs';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { sendToPlatform } from './cover';

export const ROLES = [
  'Farmer',
  'Farmer group or chama',
  'Cooperative',
  'Insurance company',
  'Lender',
  'Veterinary office',
  'Buyer or processor',
  'Government or university',
  'Other',
];

// Audience page key -> role shown in the contact form
export const ROLE_BY_PAGE = {
  farmers: 'Farmer',
  groups: 'Farmer group or chama',
  cooperatives: 'Cooperative',
  insurers: 'Insurance company',
  lenders: 'Lender',
  vets: 'Veterinary office',
  buyers: 'Buyer or processor',
  governments: 'Government or university',
};

export const setContactRole = (page) => {
  try { sessionStorage.setItem('imfuyo-contact-role', ROLE_BY_PAGE[page] || ''); } catch (e) { /* ignore */ }
};
export const getContactRole = () => {
  try {
    const r = sessionStorage.getItem('imfuyo-contact-role') || '';
    sessionStorage.removeItem('imfuyo-contact-role');
    return r;
  } catch (e) { return ''; }
};

// Standard first-contact record. Cover uses the same field names for its own contact form.
// Extra details (organisation, county, livestock and so on) are collected afterwards, in conversation.
export async function submitLead({ name, email, phone, role, message, consent, subject, source, extra }) {
  // The same enquiry also goes to the Imfuyo Platform, where the team follows it up. It never blocks the website.
  sendToPlatform({ kind: subject || `${role || 'Website'} enquiry`, name, phone, email, county: (extra && extra.county) || '', role, message, consent, source, extra });
  return addDoc(collection(db, 'messages'), {
    name: (name || '').trim(),
    role: role || '',
    phone: (phone || '').trim(),
    email: (email || '').trim(),
    message: (message || '').trim(),
    subject: subject || `${role || 'Website'} enquiry`,
    consent: !!consent,
    source: source || 'website-contact',
    ...(extra || {}),
    sourcePage: typeof window !== 'undefined' ? window.location.pathname : '',
    timestamp: serverTimestamp(),
    status: 'unread',
  });
}
